import type { GetPagesCountParams, SearchPagesParams } from "./types";

export const pagesKeys = {
  all: ["pages"] as const,
  lists: () => [...pagesKeys.all, "list"] as const,
  list: (params: SearchPagesParams) => [...pagesKeys.lists(), params] as const,
  details: () => [...pagesKeys.all, "detail"] as const,
  detail: (id: string) => [...pagesKeys.details(), id] as const,
  getPagesWithStoryBrain: (currentStoryId: string) =>
    [...pagesKeys.all, "with-story-brain", currentStoryId] as const,
  getPagesCount: (params: GetPagesCountParams) =>
    [...pagesKeys.all, "count", params] as const,
  getApiToken: (id: string) => [...pagesKeys.all, "token", id] as const,
  getCollaborationRoomTitles: (ids: string[]) =>
    [...pagesKeys.all, "collaboration-titles", ids] as const,
  getStoryTitleCount: (title: string, id: string) =>
    [...pagesKeys.all, "validate-title", title, id] as const,
  getSessionMetadata: (path: string) =>
    [...pagesKeys.all, "session-metadata", path] as const,
  validatePageContent: (id: string) =>
    [...pagesKeys.all, "validate-content", id] as const,
  getAccessibleLivePages: (folderId?: string) =>
    [...pagesKeys.all, "accessible-live-pages", folderId ?? "all"] as const,
  imported: () => [...pagesKeys.all, "imported"] as const,
};
